import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { updateFileNameByOwner } from '../../../../actions/supportingDocsActions'
import { useDispatch } from "react-redux";
import { Modal,Button } from 'react-bootstrap';

const UpdateModal = (props) => {

    const dispatch = useDispatch();

	const { register, handleSubmit, reset, setValue, formState: { errors, ...formState }} = useForm({
		mode: "onBlur",
	}),
	[inputMemberFileName, setInputMemberFileName] = useState(""),
	[inputMemberTitle, setInputMemberTitle] = useState("");

	const { isValid } = formState

	const onAdminSubmit = async (values, e) => {
		
		if (props.data) {
			values.id = (props.data !== false) ? props.data.id : ''
		}
		//console.log("values", values);
		dispatch(updateFileNameByOwner(values));
		props.close();
		props.onLoad();
		
	};

	useEffect(() => {
		// console.log("my props", props);
		if (props.data) {
			setValue('file_name', props.data.file_name)
			setInputMemberFileName(props.data.file_name);
			setInputMemberTitle("Edit File name");
			//reset();
		} 
	 }, [props, reset, setValue]);
	
	return (
		props.open && (
			<Modal show={props.open} onHide={props.close}>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title">{inputMemberTitle}</Modal.Title>
					<Button variant="outline-danger" onClick={props.close}><i className="fa fa-close"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-md-12">
						<form className="needs-validation" onSubmit={handleSubmit(onAdminSubmit)}>
							<div className="modal-body">
								<div className="form-group">
									<label>File Name<span className="text-danger">*</span></label>
									<input type="text" className="form-control" placeholder="Enter File Name"
									  defaultValue={inputMemberFileName}
									  onChange={(e) => setInputMemberFileName(e.target.value)}
									  name="file_name"
									  autoComplete="off"
									  {...register('file_name')} 
									/>	
									{errors.file_name && ( <div className="text-danger">{errors.file_name.message}</div> )}
								</div>
							
							</div>  
							<div className="modal-footer">
								<button type="submit" className="btn button"  disabled={isValid}>Submit</button>
								<button type="button" className="btn btn-outline-white" data-dismiss="modal" onClick={props.close}>Cancel</button>
							</div>
						</form>
                    </div>
                </Modal.Body>
            </Modal> 
		)
	);
}

export default UpdateModal;
